<template lang="pug">
  .component-backoffice-driver-list.row.column
    .card
      .inner-content
        template(v-for="line in data")
          h2 {{line.name}}
          table
            tr(style="text-align:left")
              th Service
              th Available seats
              th Departure time
              th Arrival time
              th Service days
            tr(v-for="(service,i) in line.services" )
              td {{++i}}
              td {{service.meta.seats_available}}/{{service.meta.seats_total}} ({{service.meta.seats_total - service.meta.seats_available}} passengers)
              td {{service.departure_time}}
              td {{service.arrival_time}}
              td {{service.days.join(", ")}}

            //pre {{service}}
          hr

    //pre {{data}}

</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

import InputForm from "../../components/structure/ui/filters/InputForm";
import BaseList from "./BaseList";
import HeaderColumns from "../../components/structure/ui/HeaderColumns";
import DriverListForm from '../../components/structure/ui/filters/DriverListForm'
import InputSwitch from "../../components/structure/ui/InputSwitch.vue";

export default {
  name: "TransitList",
  components: {
    InputSwitch,
    DriverListForm,
    HeaderColumns,
    BaseList,
    InputForm,
  },
  data: function () {
    return {
      data: null,

    }
  },
  created() {
    this.dataLoader()
  },
  methods: {
    dataLoader() {
      KeplerBackofficeSdk.transit.transit((data) => {
        this.data = data
        console.log(data)
      })
    },
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TransitList.vue?25059ce9